// extracted by mini-css-extract-plugin
export default {"navbarItem":"NavbarItem_navbarItem__vryzT","navButtonHasSub":"NavbarItem_navButtonHasSub__iU7Up","bold":"NavbarItem_bold__B7+-i"};